var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Page",
    { attrs: { titleType: "custom" } },
    [
      _c("template", { slot: "header-title" }, [
        _c("div", { staticClass: "header-title-left" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("Integration.pageHeader_LogoWMS"))),
          ]),
        ]),
      ]),
      _c(
        "template",
        { slot: "content-center" },
        [
          _c("TableView", {
            attrs: {
              data: _vm.LogoWMSStoreGroupList,
              fields: _vm.fields,
              readOnly: true,
              componentName: "LogoWMSStoreGroupTable",
            },
          }),
          _c("portal", {
            attrs: { to: "isActive" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return _c("div", {}, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          row.isActive
                            ? _vm.$t("Global_V2.active")
                            : _vm.$t("Global_V2.not_active")
                        )
                      ),
                    ]),
                  ])
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }